/* ===== Page: Solutions – Bespoke Security ===== */
import React from 'react';
import MainLayout from '@/components/Layout/MainLayout';
import BespokeHero from '@/components/Solutions/BespokeHero';
import BespokeOverviewSection from '@/components/Solutions/BespokeOverviewSection';
import BespokeProcessSection from '@/components/Solutions/BespokeProcessSection';
import ClientReviewsCarousel from '@/components/Solutions/ClientReviewsCarousel';
import BespokeCaseStudies from '@/components/Solutions/BespokeCaseStudies';
import CallToAction from '@/components/Solutions/CallToAction';

// Case studies data
const caseStudies = [
  {
    id: 1,
    title: 'Mixed Property Estate',
    description: 'A custom security solution for a 20-acre estate with diverse terrain and multiple entry points.',
    image: '/images/Solutions-Bespoke-Case-Studies-Mixed-Property.png'
  }, 
  {
    id: 2,
    title: 'Remote Solar Farm',
    description: 'Off-grid protection system for a large-scale renewable energy installation in a remote location.',
    image: '/images/Solutions-Bespoke-Case-Studies-Solar-Farm-Remote-1.png'
  }, 
  {
    id: 3,
    title: 'Multi-Use Golf Course',
    description: 'Comprehensive protection system designed for a golf course with public and private zones.',
    image: '/images/Solutions Bespoke Case Studies Multi-Use Golf Course1.png'
  }
];

// Client reviews for CRO optimization
const clientReviews = [
  {
    name: "David L.",
    company: "Property Development",
    stars: 5,
    text: "The tailored approach to our mixed-use property was exactly what we needed."
  }, 
  {
    name: "Sarah T.",
    company: "Agriculture",
    stars: 5,
    text: "Forti-Fi created a custom solution for our farm that works flawlessly year-round."
  }, 
  {
    name: "Michael R.",
    company: "Energy Sector",
    stars: 4,
    text: "Impressive adaptability for our remote solar installation requirements."
  }
];

// Process steps data
const processSteps = [
  {
    title: "01. Audit",
    description: "Analyze layout, terrain, and threat risks to understand your property's unique challenges."
  },
  {
    title: "02. Design Together",
    description: "Create a tailored solution through 3D mapping and threat simulations that address your specific concerns."
  },
  {
    title: "03. Test & Deploy",
    description: "Implement pilot-tech installation to ensure perfect alignment with your needs before full deployment."
  }
];

// Features data for the overview section
const bespokeFeatures = [
  {
    title: "Mixed Properties",
    description: "Blending above-ground/ground barriers for golf courses or estates."
  },
  {
    title: "Remote Assets",
    description: "Off-grid solar-powered sensors for pipelines or far-flung facilities."
  },
  {
    title: "Multi-Use Zones",
    description: "Separate high-security areas from public regions on private lands."
  }
];

const SolutionsBespoke = () => {
  return (
    <MainLayout>
      {/* Hero Section */}
      <BespokeHero 
        title="Security Designed for What's Unique about Your Property"
        subtitle="Complex Needs? We Architect Solutions to Outthink Threats."
      />

      {/* Overview Section */}
      <BespokeOverviewSection 
        features={bespokeFeatures}
        image="/images/solutions-bespoke-overview-option-1.png"
        buttonText="Discuss Your Unique Needs"
        buttonLink="/contact"
      />

      {/* Our Process */}
      <BespokeProcessSection steps={processSteps} />

      {/* Updated Client Reviews Section with Carousel */}
      <ClientReviewsCarousel reviews={clientReviews} />

      {/* Case Studies */}
      <BespokeCaseStudies caseStudies={caseStudies} />

      {/* CTA Section */}
      <CallToAction 
        title="Your Space, Your Rules"
        subtitle="Contact our team to discuss a custom security solution that addresses your property's unique challenges."
        primaryButtonText="Ask About Custom Design"
        primaryButtonLink="/contact"
        secondaryButtonText="View All Solutions"
        secondaryButtonLink="/solutions"
      />
    </MainLayout>
  );
};

export default SolutionsBespoke;
